// i18n configuration
import { I18n } from "i18n-js";
import { Platform } from "react-native";
import { ar, fr, en } from "./translation/index";

const i18n = new I18n({
  ar,
  fr,
  en,
});
i18n.defaultLocale = "ar";

const availableLocales = [
  {
    name: "Arabic",
    code: "ar",
  },
  {
    name: "French",
    code: "fr",
  },
  {
    name: "English",
    code: "en",
  },
];

// On web, try to read saved locale synchronously from localStorage
// This ensures the correct language is used on first render
let initialLocale = "ar"; // Default for Algerian users

try {
  if (
    Platform.OS === "web" &&
    typeof window !== "undefined" &&
    window.localStorage
  ) {
    const savedLocale = window.localStorage.getItem("appLocale");
    if (savedLocale && ["ar", "fr", "en"].includes(savedLocale)) {
      initialLocale = savedLocale;
    }
  }
} catch (error) {
  // localStorage not available (SSR or private browsing)
}

i18n.locale = initialLocale;

export { availableLocales };
export default i18n;
